export const GTM_ID = "GTM-N5ZP8Q86";

export const initializeGTM = (userId: string): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ userid: userId });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;

  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const firstScript = document.getElementsByTagName("script")[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  }
};
